import { onMounted, onBeforeUnmount } from "vue";
import { tenantChannel } from "@/plugins/echo";
import { useRuleEnginedStore } from "@/modules/rule_engine/store";

type RuleEngineAiSummaryGeneratedEvent = {
	target_type: "rule_model_version" | "rule_set";
	target_uuid: string;
	ai_summary: string | null;
	ai_summary_status: App.Enums.AiSummaryStatus;
};

/**
 * Subscribes to the rule model version's private Reverb channel for as long as
 * the calling component is mounted, so AI summaries (for the version and every
 * rule set within it) appear as soon as the background job generates them —
 * no polling.
 */
export const useRuleEngineAiSummaryChannel = (
	ruleModelVersionUuid: string
) => {
	const store = useRuleEnginedStore();
	const channelName = tenantChannel(
		`App.Models.RuleEngine.RuleModelVersion.${ruleModelVersionUuid}`
	);

	const handleEvent = (event: RuleEngineAiSummaryGeneratedEvent) => {
		store.applyAiSummaryEvent(event);
	};

	onMounted(() => {
		window.Echo.private(channelName).listen(
			".RuleEngineAiSummaryGenerated",
			handleEvent
		);
	});

	onBeforeUnmount(() => {
		window.Echo.leave(channelName);
	});
};
